import { environment } from '../../environments/environment';

export class ServicesDataConfiguration {
  private _apiBaseURL: string = environment.apiURL;
  private _apiInvoicesURL: string = 'api/invoice';
  private _apiPinsURL: string = 'api/pin'

  public get apiBaseURL(): string {
    return this._apiBaseURL;
  }

  public get getInvoice(): string {
    return this._apiInvoicesURL;
  }

  public get getPins(): string {
    return this._apiPinsURL;
  }
}
